function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117 60.5C117 91.9802 91.4802 117.5 60 117.5C28.5198 117.5 3 91.9802 3 60.5C3 29.0198 28.5198 3.5 60 3.5C91.4802 3.5 117 29.0198 117 60.5Z",
  stroke: "#B01421",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47 89.5H74C76.49 89.5 78.62 88 79.52 85.84L88.58 64.69C88.85 64 89 63.28 89 62.5V56.5C89 53.2 86.3 50.5 83 50.5H62L63.92 38.79L64.01 37.83C64.01 36.6 63.5 35.46 62.69 34.65L59.51 31.5L42.74 49.27C41.66 50.35 41 51.85 41 53.5V83.5C41 86.8 43.7 89.5 47 89.5ZM45 53.5L60 37L57 54.5H85V62.5L75 85.5H45V53.5ZM31 53.5H37V89.5H31V53.5Z",
  fill: "#B01421"
});

function SvgLikeCircle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeCircle2);
export default __webpack_public_path__ + "static/media/likeCircle2.de1aa699.svg";
export { ForwardRef as ReactComponent };